import { UserRole } from '@musicville/shared';
import type { IconName } from '@/components/brand/Icon';

export interface PortalNavItem {
  to: string;
  labelKey: string;
  icon: IconName;
  roles: readonly UserRole[];
}

const EVERYONE = [UserRole.STUDENT, UserRole.TEACHER, UserRole.ADMIN] as const;
const STUDENTS = [UserRole.STUDENT] as const;
const TEACHERS = [UserRole.TEACHER, UserRole.ADMIN] as const;

export const PORTAL_NAV: readonly PortalNavItem[] = [
  { to: '/portal', labelKey: 'portal.nav.home', icon: 'home', roles: EVERYONE },
  { to: '/portal/schedule', labelKey: 'portal.nav.schedule', icon: 'calendar', roles: EVERYONE },
  {
    to: '/portal/explore',
    labelKey: 'portal.nav.explore',
    icon: 'book-open',
    roles: STUDENTS,
  },
  { to: '/portal/students', labelKey: 'teacher.nav.students', icon: 'users', roles: TEACHERS },
  {
    to: '/portal/attendance',
    labelKey: 'teacher.nav.attendance',
    icon: 'user-check',
    roles: TEACHERS,
  },
  { to: '/portal/rooms', labelKey: 'portal.nav.rooms', icon: 'door', roles: STUDENTS },
  {
    to: '/portal/community',
    labelKey: 'portal.nav.community',
    icon: 'message-circle',
    roles: EVERYONE,
  },
  {
    to: '/portal/payments',
    labelKey: 'portal.nav.payments',
    icon: 'credit-card',
    roles: STUDENTS,
  },
  {
    to: '/portal/notifications',
    labelKey: 'portal.nav.notifications',
    icon: 'bell',
    roles: EVERYONE,
  },
  { to: '/portal/profile', labelKey: 'portal.nav.profile', icon: 'user', roles: EVERYONE },
];

export function isTeacherRole(role: UserRole | undefined): boolean {
  return role === UserRole.TEACHER || role === UserRole.ADMIN;
}

export function navForRole(role: UserRole | undefined): readonly PortalNavItem[] {
  if (!role) return [];
  return PORTAL_NAV.filter((item) => item.roles.includes(role));
}
